import Header from "../components/Header";
import Footer from "../components/Footer";
import { usePublicPageMeta } from "../hooks/usePageMeta";

export default function PrivacyPolicy() {
  usePublicPageMeta("/privacy");
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <Header />
      
      <main className="pt-28 lg:pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <h1 
            className="text-3xl lg:text-4xl mb-4"
            style={{ color: '#0f1d2f' }}
          >
            Privacy Policy
          </h1>
          <p className="text-sm mb-12" style={{ color: '#0f1d2f', opacity: 0.5 }}>
            Last updated: October 16, 2026
          </p>

          <div className="space-y-10" style={{ color: '#0f1d2f' }}>
            <section>
              <h2 className="text-xl mb-4">1. Introduction</h2>
              <p className="text-base leading-relaxed opacity-75">
                American Farmstand ("we," "our," or "us") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services.
              </p>
            </section>

            <section>
              <h2 className="text-xl mb-4">2. Information We Collect</h2>
              <p className="text-base leading-relaxed opacity-75 mb-4">
                We may collect information about you in various ways, including:
              </p>
              <h3 className="text-lg mb-2">Personal Information</h3>
              <ul className="list-disc pl-6 space-y-2 text-base opacity-75">
                <li>Name, email address, and contact information</li>
                <li>Billing and shipping addresses</li>
                <li>Payment information (processed securely through Stripe)</li>
                <li>Account credentials</li>
              </ul>
              <h3 className="text-lg mt-4 mb-2">Automatically Collected Information</h3>
              <ul className="list-disc pl-6 space-y-2 text-base opacity-75">
                <li>IP address and browser type</li>
                <li>Device information</li>
                <li>Pages visited and time spent on our site</li>
                <li>Referring website addresses</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl mb-4">3. How We Use Your Information</h2>
              <p className="text-base leading-relaxed opacity-75 mb-4">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-base opacity-75">
                <li>Process transactions and fulfill orders</li>
                <li>Manage your account and membership</li>
                <li>Send you order confirmations and updates</li>
                <li>Respond to your inquiries and provide customer support</li>
                <li>Send promotional communications (with your consent)</li>
                <li>Improve our website and services</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl mb-4">4. Information Sharing</h2>
              <p className="text-base leading-relaxed opacity-75 mb-4">
                We do not sell your personal information. We may share your information with:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-base opacity-75">
                <li><strong>Farms:</strong> To fulfill your orders, we share necessary order details with the farms you purchase from</li>
                <li><strong>Service Providers:</strong> Third-party vendors who assist with payment processing (Stripe), email services, and website hosting</li>
                <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl mb-4">5. Data Security</h2>
              <p className="text-base leading-relaxed opacity-75">
                We implement appropriate technical and organizational security measures to protect your personal information. Payment information is processed through Stripe's secure, PCI-compliant platform and is never stored on our servers.
              </p>
            </section>

            <section>
              <h2 className="text-xl mb-4">6. Your Rights</h2>
              <p className="text-base leading-relaxed opacity-75 mb-4">
                Depending on your location, you may have the following rights:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-base opacity-75">
                <li>Access, correct, or delete your personal information</li>
                <li>Opt out of marketing communications</li>
                <li>Request a copy of your data</li>
                <li>Lodge a complaint with a supervisory authority</li>
              </ul>
              <p className="text-base leading-relaxed opacity-75 mt-4">
                <strong>California Residents:</strong> Under the California Consumer Privacy Act (CCPA), you have additional rights including the right to know what personal information we collect and the right to request deletion.
              </p>
            </section>

            <section>
              <h2 className="text-xl mb-4">7. Cookies</h2>
              <p className="text-base leading-relaxed opacity-75">
                We use cookies and similar technologies to enhance your experience, analyze site traffic, and for marketing purposes. You can control cookie preferences through your browser settings.
              </p>
            </section>

            <section>
              <h2 className="text-xl mb-4">8. Children's Privacy</h2>
              <p className="text-base leading-relaxed opacity-75">
                Our services are not intended for individuals under 18 years of age. We do not knowingly collect personal information from children under 18.
              </p>
            </section>

            <section>
              <h2 className="text-xl mb-4">9. Changes to This Policy</h2>
              <p className="text-base leading-relaxed opacity-75">
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.
              </p>
            </section>

            <section>
              <h2 className="text-xl mb-4">10. Contact Us</h2>
              <p className="text-base leading-relaxed opacity-75">
                If you have questions about this Privacy Policy or our practices, please contact us at:
              </p>
              <p className="text-base opacity-75 mt-4">
                <strong>Email:</strong> hello@american-farmstand.com<br />
                <strong>Address:</strong> American Farmstand, United States
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
